import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, ArrowLeft, AlertTriangle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useAuth();
  const [seconds, setSeconds] = useState(8);

  // Auto-redirect to safe destination
  useEffect(() => {
    const target = token ? "/" : "/login";
    const timer = setInterval(() => setSeconds(s => Math.max(0, s - 1)), 1000);
    const redirect = setTimeout(() => navigate(target, { replace: true }), 8000);
    return () => { clearInterval(timer); clearTimeout(redirect); };
  }, [navigate, token]);

  const target = token ? "/" : "/login";
  const targetLabel = token ? "Dashboard" : "Login";

  return (
    <div className="min-h-screen flex items-center justify-center px-6"
      style={{ background: "var(--gio-bg, #0a0f1a)" }}
      data-testid="not-found-page">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full"
          style={{ background: "var(--gio-primary-soft, rgba(255,51,0,0.12))" }}>
          <AlertTriangle size={28} style={{ color: "var(--gio-primary, #ff3300)" }} />
        </div>
        <div>
          <div className="overline mb-2" style={{ color: "var(--gio-muted-2, #94a3b8)" }}>404 · PATH NOT FOUND</div>
          <h1 className="font-heading text-4xl text-white">Page not in the lounge.</h1>
          <p className="mt-3 text-sm" style={{ color: "var(--gio-muted-2, #94a3b8)" }}>
            The path <span className="font-mono-ui px-1.5 py-0.5 rounded text-[12px]"
              style={{ background: "var(--gio-surface-hi, #1f2937)", color: "var(--gio-secondary, #14b8a6)" }}>
              {location.pathname}{location.search}
            </span> doesn't match any GP App route.
          </p>
        </div>
        <div className="flex gap-3 justify-center">
          <button onClick={() => navigate(-1)} data-testid="not-found-back" className="btn-ghost inline-flex items-center gap-2">
            <ArrowLeft size={14} /> Back
          </button>
          <button onClick={() => navigate(target, { replace: true })} data-testid="not-found-home"
            className="btn-primary inline-flex items-center gap-2">
            <Home size={14} /> Go to {targetLabel}
          </button>
        </div>
        <div className="text-[11px]" style={{ color: "var(--gio-muted-3, #64748b)" }}>
          Auto-redirecting in {seconds}s…
        </div>
      </div>
    </div>
  );
}
